import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app';

interface ModalState {
  visible: boolean;
  data: {
    orderID: string | undefined;
    customerName: string;
    type: number | undefined;
  };
}

const initialState: ModalState = {
  visible: false,
  data: {
    orderID: undefined,
    customerName: '',
    type: undefined,
  },
};

const orderTaskModalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openOrderTaskModal(
      state,
      action: PayloadAction<{
        orderID?: string | undefined;
        customerName: string;
        type?: number | undefined;
      }>
    ) {
      state.visible = true;
      state.data.orderID = action.payload?.orderID;
      state.data.customerName = action.payload?.customerName;
      state.data.type = action.payload?.type;
    },
    cancelOrderTaskModal(state) {
      state.visible = false;
      state.data = {
        orderID: undefined,
        customerName: '',
        type: undefined,
      };
    },
  },
  extraReducers: {},
});

const { actions, reducer: orderTaskModalReducer } = orderTaskModalSlice;

export const { openOrderTaskModal, cancelOrderTaskModal } = actions;

export default orderTaskModalReducer;

export const selectOrderTaskModal = (state: RootState): ModalState =>
  state.orderTaskModal as ModalState;
